import { LoadableBackground, type LoadableType } from '@confluence/loadable';

import type { CommentNotificationsProps } from '../src/CommentNotifications.tsx';

export const CommentNotifications: LoadableType<CommentNotificationsProps> = LoadableBackground({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-CommentNotifications" */ '../src/CommentNotifications.tsx'
			)
		).CommentNotifications,
});
